import { LoadingIndicator } from "~/components/ui";
import { useTranslation } from "~/i18n";

export function SurveySiteRouteFallback() {
  const { t } = useTranslation();

  return (
    <section
      aria-busy="true"
      className="flex h-[clamp(20rem,65vh,48rem)] min-h-80 w-full min-w-0 items-center justify-center gap-3 rounded-panel border border-border bg-surface px-6 text-muted shadow-raised"
    >
      <LoadingIndicator className="size-5" />
      <p role="status" className="text-sm font-medium leading-6">
        {t("surveyDetail.siteMap.loading")}
      </p>
    </section>
  );
}
